import {
  handleResp,
  getURLWithQueryParams,
  getDefaultHeaders,
  extendFetchOptions,
} from "./utils";
import type { StandardObject } from "utils";
import type {
  WrappedCashifyFunction,
  WrappedCashifyPageableQuery,
  GenericResponse,
  Sortable,
} from "./utils";

export interface JobExecutionService {
  listExecutionHistory: ReturnType<typeof listExecutionHistory>;
  getExecutionHistoryDetail: ReturnType<typeof getExecutionHistoryDetail>;
};

export type JobType = "ONE_OFF" | "CRONJOB";

export type JobExecutionStatus = "COMPLETED" | "FAILED" | "RUNNING" | "CANCELLED";

// execution history
export interface JobExecutionSearchCriteria extends Sortable {
  id?: number;
  taskName?: string;
  taskCategory?: string;
  jobId?: number;
  jobName?: string;
  jobType?: JobType[];
  executionStatus?: JobExecutionStatus[];
  "startTime.from"?: string;
  "startTime.to"?: string;
  "endTime.from"?: string;
  "endTime.to"?: string;

};

export interface JobExecutionDTO {
  id: number;
  taskName: string;
  taskCategory: string;
  jobId: number;
  jobName: string;
  jobType: JobType;
  status: JobExecutionStatus;
  startTime?: string;
  endTime?: string;
};

export interface JobExecutionDetail extends JobExecutionDTO {
  inputParameters?: StandardObject;
  outputResults?: StandardObject;
  exception?: StandardObject;
};

export const listExecutionHistory: WrappedCashifyPageableQuery<JobExecutionSearchCriteria, JobExecutionDTO> = ({ urlPrefix, options }) => {
  return async (queryParams) => {
    let url = getURLWithQueryParams(
      `${urlPrefix}/api/v1/task/job-execution/history`,
      queryParams,
    );
    let opts = extendFetchOptions(
      {
        method: "GET",
        headers: getDefaultHeaders(),
      },
      options,
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};

export const getExecutionHistoryDetail: WrappedCashifyFunction<{ id: number }, GenericResponse<JobExecutionDetail>> = ({ urlPrefix, options }) => {
  return async ({ id }) => {
    let url = `${urlPrefix}/api/v1/task/job-execution/history/${id}`;
    let opts = extendFetchOptions(
      {
        method: "GET",
        headers: getDefaultHeaders(),
      },
      options,
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};